import React from "react"

import ReactTable from "react-table"

import { APIPost, APIGet } from "services/APIRequest"
import ConfigHost from "services/ConfigHost"

import { arrayObject } from "ConvertKey"
import UrlServer from "configs/UrlServer"
import Auth from "auth"
import Lg from "language"
import { ErrorsCallback, SuccessCallback, WarningCallback } from "alertService"

import { compose } from "recompose"
import { connect } from "react-redux"

import { ISOToDateFormat, ISOToDateYMDAndFullTime, MMDDYYYYForDatetime } from "helpers/ConvertDate"
import { thaiBath } from "helpers/ConvertFormat"
import { maskTel } from "helpers/ConvertMaskData"
import Datetime from "react-datetime";
import { replaceNumberQuestion } from "helpers/ConvertString"
import * as Alert from "alertService"

import wordingQuestion from "configs/wordingQuestion.jsx"

// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles"

import FormControl from "@material-ui/core/FormControl";
import InputLabel from "@material-ui/core/InputLabel";

// @material-ui/icons
import ViewListIcon from '@material-ui/icons/ViewList';
import CloudDownloadIcon from "@material-ui/icons/CloudDownload"
import SearchIcon from "@material-ui/icons/Search";
import CachedIcon from '@material-ui/icons/Cached';

// @material-ui/Dialog 
import Dialog, { DialogProps } from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';

// core components
import GridContainer from "components/Grid/GridContainer.jsx"
import GridItem from "components/Grid/GridItem.jsx"
import CustomInput from "components/CustomInput/CustomInput.jsx"
import Button from "components/CustomButtons/Button.jsx"
import Card from "components/Card/Card.jsx"
import CardBody from "components/Card/CardBody.jsx"
import CardIcon from "components/Card/CardIcon.jsx"
import CardHeader from "components/Card/CardHeader.jsx"
import Select from "components/CustomSelects/Select.jsx"
import Autocomplete from "components/Autocomplete/Select.jsx";

import { cardTitle } from "assets/jss/material-dashboard-pro-react.jsx"
import regularFormsStyle from "assets/jss/material-dashboard-pro-react/views/regularFormsStyle"
import FormLabel from "@material-ui/core/FormLabel"
import { colors } from "@material-ui/core"
const styles = {
  ...regularFormsStyle,
  cardIconTitle: {
    ...cardTitle,
    marginTop: "15px",
    marginBottom: "0px"
  },
  marginHR: {
    marginTop: "35px",
    marginBottom: "-5px"
  },
  mt4: {
    marginTop: "15px"
  }
}

var userCode = Auth.getUserData()

class ReportCaseSFPage extends React.Component {
  constructor(props) {
    super(props)
    this.state = {

      dataTableList: [],
      dataTableListRaw: [],

      dataListImport: [],
      selectDataListImport: null,

      startDateTime: null,
      endDateTime: null,
      totalCreditAll: 0,
      totalCreditSuccess: 0,
      totalCreditUnsuccess: 0,
    }
  }
  componentDidMount() {
    var startDateTime = localStorage.getItem("sms-raw_report-start-date")
    var endDateTime = localStorage.getItem("sms-raw_report-end-date")
    this.setState({
      startDateTime: startDateTime != null ? MMDDYYYYForDatetime(startDateTime) : MMDDYYYYForDatetime(),
      endDateTime: endDateTime != null ? MMDDYYYYForDatetime(endDateTime) : MMDDYYYYForDatetime(),
    }, () => {
      this.onDownloadListImport(() => {
      })
    })
  }
  onDownloadListImport(callback) {
    Alert.Loading(true)
    const dataToSend = {
    }
    APIPost(UrlServer.URL_POST_SMS_DATA_IMPORT_LIST, dataToSend, (datas) => {
      var newConvertDatas = arrayObject(datas.datas, [
        {
          oldKey: "_id",
          newKey: "value"
        },
        {
          oldKey: "_id",
          newKey: "label"
        },
        {
          oldKey: "count",
          newKey: "count"
        },
        {
          oldKey: "created_date_iso",
          newKey: "created_date_iso"
        },
        {
          oldKey: "send_sms_date",
          newKey: "send_sms_date"
        },
      ]
      )
      newConvertDatas.map((row, index) => {
        newConvertDatas[index].label += " จำนวนรายการตอนนำเข้า " + (newConvertDatas[index].count ? " ( " + thaiBath(newConvertDatas[index].count, false) + " )" : "( - )")
      })
      const no_import = [{
        label: Lg.ts("รายการที่ไม่ได้นำเข้าจาก Excel ไฟล์"),
        value: "list_no_import",
      }]
      this.setState({
        dataListImport: [...no_import, ...newConvertDatas],
        statusWaitingUpdate: false
      }, () => {
        Alert.LoadingClose()
        if (callback) callback()
      })
    })

  }
  loadDataTableList = (writeExcel = false, callback) => {
    if (!this.state.startDateTime) {
      WarningCallback(Lg.ts("ต้องการข้อมูล") + " : " + Lg.ts("วันที่เริ่ม (วันส่ง SMS)"))
      return
    } else if (!this.state.endDateTime) {
      WarningCallback(Lg.ts("ต้องการข้อมูล") + " : " + Lg.ts("ถึงวันที่ (วันส่ง SMS)"))
      return
    }
    Alert.Loading()
    const dateS = this.state.startDateTime ? this.state.startDateTime : null
    const dateE = this.state.endDateTime ? new Date(new Date(this.state.endDateTime).getTime() + 86399000).toISOString() : null
    var dataForSend = {
      userTypeCode: userCode,
      startDateTime: dateS,
      endDateTime: dateE,
      selectDataListImport: this.state.selectDataListImport
    }
    if (writeExcel) {
      dataForSend.isExportExcel = true
    }
    APIPost(UrlServer.URL_POST_SMS_RAW_DATA_REPORT, dataForSend, ({ datas }) => {

      var totalCreditAll = 0
      var totalCreditSuccess = 0
      var totalCreditUnsuccess = 0
      var data_loop = writeExcel ? datas.datas : datas
      if (typeof data_loop == "object") {
        data_loop.map((row) => {
          totalCreditAll += row.credit_per_msg
          if (row.status_sent_success == "2") {
            totalCreditSuccess += row.credit_per_msg
          } else if (row.status_sent_success == "1") {
            totalCreditUnsuccess += row.credit_per_msg
          }
        })
      }
      var dataTableList = this.renderListData(writeExcel ? datas.datas : datas)
      this.setState({
        dataTableListRaw: datas,
        dataTableList: dataTableList,
        totalCreditAll: totalCreditAll,
        totalCreditSuccess: totalCreditSuccess,
        totalCreditUnsuccess: totalCreditUnsuccess,
      }, () => {
        Alert.LoadingClose()
        if (callback) callback(datas)
      })
    })
  }
  handleCheckStatus = () => {
    Alert.Loading()
    var dataForSend = {
    }
    APIPost(UrlServer.URL_POST_SEND_SMS_RECHECK_STATUS, dataForSend, ({ datas }) => {

    })
  }
  handleChange = (name, val) => {

    this.setState({
      [name]: val
    })
  }
  handleChangeState = name => event => {
    this.setState({
      [name]: event.target.value
    })
  }

  handleSearch = () => {
    this.loadDataTableList(false)
  }
  handleDownloadExcelFile = () => {
    this.loadDataTableList(true, (datas) => {
      const response = {
        file: ConfigHost.HOST_API + "reports/" + datas.fileName,
      };
      document.location = response.file
    })
  }
  handleChangeAutoCompleteNormally = name => value => {
    this.setState({
      [name]: value,
    }, () => {

    })
  }
  handleDateTimeChange = (name, date) => {
    const dateF = new Date(date).toISOString()
    this.setState({
      [name]: dateF
    }, () => {
      if (name == "startDateTime") {
        localStorage.setItem("sms-raw_report-start-date", dateF)
      } else if (name == "endDateTime") {
        localStorage.setItem("sms-raw_report-end-date", dateF)
      }
    })
  }
  renderListData = data => {
    return data.map((CData, key) => {
      return {
        id: (key + 1),
        mobile_number: (CData.sms_id && CData.sms_id.mobile_number) ? maskTel(CData.sms_id.mobile_number) : "-",
        // mobile_number: CData.sms_id.mobile_number ? CData.sms_id.mobile_number : "-",
        message: CData.msg ? CData.msg : "-",
        message_length: (CData.sms_id && CData.sms_id.message_length) ? CData.sms_id.message_length + "" : "-",
        message_lenguage: (CData.sms_id && CData.sms_id.message_lenguage) ? CData.sms_id.message_lenguage + "" : "-",
        created_date_iso: CData.created_date_iso ? ISOToDateYMDAndFullTime(CData.created_date_iso) : "-",
        credit_per_msg: CData.credit_per_msg ? thaiBath(CData.credit_per_msg, false) : "-",
        status_sent_success: CData.status_sent_success == "2" ? "ผ่าน" : (CData.status_sent_success == "1" ? "ไม่ผ่าน" : "ยังไม่อัพเดท"),
        created_by_user: (CData.created_by_user && CData.created_by_user.user_data_id && CData.created_by_user.user_data_id.first_name && CData.created_by_user.user_data_id.last_name ? (CData.created_by_user.user_data_id.first_name + " " + CData.created_by_user.user_data_id.last_name) : "-"),
        actions: (
          <div
          // className="actions-right"
          >
            {/* <Button
              size="sm"
              round
              color="danger"
              className={this.props.classes.mb4}
              onClick={e => this.handleDeleteData(CData)}
            >
              <DeleteIcon className={this.props.classes.icons} />
              ลบ
            </Button>{" "}
            <Button
              size="sm"
              round
              color="info"
              className={this.props.classes.mb4}
              onClick={e => this.handleSendSMSNow(CData)}
            >
              <SendIcon className={this.props.classes.icons} />
              ส่งข้อความ
            </Button> */}
          </div>
        ),
      }
    })
  }
  render() {
    const { classes } = this.props
    const userData = Auth.getUserData()
    var columnsTable = [
      {
        Header: "#",
        accessor: "id",
        width: 50
      },
      // {
      //   Header: Lg.ts("ตั้งค่าต่างๆ"),
      //   accessor: "actions",
      //   sortable: false,
      //   filterable: false,
      //   width: 220
      // },
      {
        Header: Lg.ts("เบอร์มือถือ"),
        accessor: "mobile_number",
        width: 130,
        filterMethod: (filter, row) => {
          return row.mobile_number.toLowerCase().indexOf(filter.value.toLowerCase()) >= 0;
        }
      },
      {
        Header: Lg.ts("ส่งเมื่อ"),
        accessor: "created_date_iso",
        width: 170,
        filterMethod: (filter, row) => {
          return row.created_date_iso.toLowerCase().indexOf(filter.value.toLowerCase()) >= 0;
        }
      },
      {
        Header: Lg.ts("ข้อความ"),
        accessor: "message",
        width: 330,
        filterMethod: (filter, row) => {
          return row.message.toLowerCase().indexOf(filter.value.toLowerCase()) >= 0;
        }
      },
      {
        Header: Lg.ts("จำนวนอักษร"),
        accessor: "message_length",
        filterMethod: (filter, row) => {
          return row.message_length.toLowerCase().indexOf(filter.value.toLowerCase()) >= 0;
        }
      },
      {
        Header: Lg.ts("ภาษาของข้อความ"),
        accessor: "message_lenguage",
        filterMethod: (filter, row) => {
          return row.message_lenguage.toLowerCase().indexOf(filter.value.toLowerCase()) >= 0;
        }
      },
      {
        Header: Lg.ts("เครดิตต่อ msg"),
        accessor: "credit_per_msg",
        filterMethod: (filter, row) => {
          return row.credit_per_msg.toLowerCase().indexOf(filter.value.toLowerCase()) >= 0;
        }
      },
      {
        Header: Lg.ts("สถานะการส่ง SMS"),
        accessor: "status_sent_success",
        filterMethod: (filter, row) => {
          return row.status_sent_success.toLowerCase().indexOf(filter.value.toLowerCase()) >= 0;
        }
      },
      {
        Header: Lg.ts("ผู้ส่ง"),
        accessor: "created_by_user",
        filterMethod: (filter, row) => {
          return row.created_by_user.toLowerCase().indexOf(filter.value.toLowerCase()) >= 0;
        }
      },

    ]
    return (
      <div className={"card-space"} >
        <GridContainer >
          <GridItem xs={12}>
            <Card>
              <CardHeader color="info" icon>
                <CardIcon color="info">
                  <ViewListIcon />
                </CardIcon>
                <h4 className={classes.cardIconTitle}>{Lg.ts("ออกรายงาน")}</h4>
              </CardHeader>
              <CardBody>
                <GridContainer>
                  <GridItem xs={12} sm={12} md={6} className="date-responsive">
                    <InputLabel className={classes.label}>
                      {Lg.ts("วันที่เริ่ม (วันส่ง SMS)")}
                    </InputLabel>
                    <br />
                    <FormControl fullWidth>
                      {
                        (this.state.startDateTime) ?
                          <Datetime
                            timeFormat={false}
                            defaultValue={this.state.startDateTime}
                            onChange={e => this.handleDateTimeChange("startDateTime", e)}
                            inputProps={{
                              placeholder: Lg.ts("กดเลือกวันที่ตรงนี้"), readOnly: true
                            }}
                          />
                          : null
                      }
                      {
                        !this.state.startDateTime ?
                          <small className="txt-c-r">* {Lg.ts("จำเป็นต้องใส่")}</small>
                          : null
                      }

                    </FormControl>
                  </GridItem>
                  <GridItem xs={12} sm={12} md={6} className="date-responsive">
                    <InputLabel className={classes.label}>
                      {Lg.ts("ถึงวันที่ (วันส่ง SMS)")}
                    </InputLabel>
                    <br />
                    <FormControl fullWidth>
                      {
                        (this.state.endDateTime) ?
                          <Datetime
                            timeFormat={false}
                            defaultValue={this.state.endDateTime}
                            onChange={e => this.handleDateTimeChange("endDateTime", e)}
                            inputProps={{ placeholder: Lg.ts("กดเลือกวันที่ตรงนี้"), readOnly: true }}
                          />
                          : null
                      }

                      {
                        !this.state.endDateTime ?
                          <small className="txt-c-r">* {Lg.ts("จำเป็นต้องใส่")}</small>
                          : null
                      }
                    </FormControl>
                  </GridItem>
                  <GridItem xs={12} >
                    <br />
                    {
                      !this.state.statusWaitingUpdate ?
                        <Autocomplete
                          handleChange={this.handleChangeAutoCompleteNormally}
                          value={this.state.selectDataListImport}
                          dataList={this.state.dataListImport}
                          id="selectDataListImport"
                          label={Lg.ts("เลือกชื่อรอบการ Import") + "( " + Lg.ts("ถ้าไม่เลือกหมายถึงเลือกหมด") + " )"}
                          multi
                        />
                        : null
                    }
                  </GridItem>
                </GridContainer>
                <form>
                  <GridContainer >
                    <GridItem xs={12} sm={12} md={12}>

                      <GridContainer className={classes.mt4}>
                        <GridItem xs={12} sm={12} md={12}>
                          <Button
                            round
                            color="primary"
                            onClick={this.handleSearch}
                          >
                            <SearchIcon className={classes.icons} />
                            {Lg.ts("ค้นหา")}
                          </Button>
                          {" "}
                          <Button
                            round
                            color="info"
                            onClick={this.handleDownloadExcelFile}
                          >
                            <CloudDownloadIcon className={classes.icons} />
                            {Lg.ts("ค้นหาและดาวน์โหลด Excel")}
                          </Button>
                          {" "}
                          <Button
                            round
                            color="warning"
                            onClick={e => this.handleCheckStatus()}
                          >
                            <CachedIcon className={classes.icons} />
                            {Lg.ts("Run ตัวตรวจสอบสถานะ")}
                          </Button>
                        </GridItem>
                      </GridContainer>
                      <hr />
                      <GridContainer className={classes.mt4}>
                        <GridItem xs={12} sm={12} md={12}>
                          <span>{Lg.ts("จำนวน")} {thaiBath(this.state.dataTableList.length, false)} {Lg.ts("รายการ")}</span>
                          <span> / {Lg.ts("จำนวนเครดิตที่ใช้ทั้งหมด")} {thaiBath(this.state.totalCreditAll, false)} {Lg.ts("เครดิต")}</span>
                          <span> / {Lg.ts("จำนวนเครดิตที่ใช้ส่งสำเร็จ")} {thaiBath(this.state.totalCreditSuccess, false)} {Lg.ts("เครดิต")}</span>
                          <span> / {Lg.ts("จำนวนเครดิตที่ใช้ส่งไม่สำเร็จ")} {thaiBath(this.state.totalCreditUnsuccess, false)} {Lg.ts("เครดิต")}</span>
                          <ReactTable
                            className="table-scroll"
                            data={this.state.dataTableList}
                            filterable
                            columns={columnsTable}
                            defaultPageSize={20}
                            showPaginationTop
                          />
                        </GridItem>
                      </GridContainer>
                    </GridItem>
                  </GridContainer>
                </form>
              </CardBody>
            </Card>
          </GridItem>
        </GridContainer>
      </div>
    )
  }
}

export default withStyles(styles)(ReportCaseSFPage)
